
export const CLOSE_VIDEO = 'CLOSE_VIDEO';
export const SHOW_VIDEO = 'SHOW_VIDEO';




// WEBPACK FOOTER //
// ./src/components/Banner/BannerActionTypes.js